import { render, staticRenderFns } from "./ProjectVotingReviewStatus.vue?vue&type=template&id=7a6cf4b5&scoped=true&"
import script from "./ProjectVotingReviewStatus.vue?vue&type=script&lang=ts&"
export * from "./ProjectVotingReviewStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6cf4b5",
  null
  
)

export default component.exports